export const flattenToKycArray = <T extends object>(
	obj: T
): { [k: string]: unknown }[] => {
	const aggregated = Object.entries(obj).reduce<Record<string, unknown>>(
		(acc, [key, value]) => {
			acc[key] = value;
			return acc;
		},
		{}
	);

	return Object.keys(aggregated).length ? [aggregated] : [];
};

export const kycArrayToFormPartial = <T>(
	kycArray: { [k: string]: unknown }[]
): Partial<T> => {
	const result: Partial<Record<string, unknown>> = {};

	for (const entry of kycArray) {
		for (const [key, value] of Object.entries(entry)) {
			result[key] = value;
		}
	}

	return result as Partial<T>;
};
